export class SlogCtrl {
Broj : number ;
  constructor(broj ) {
        this.Broj = broj;
    }
}



// WEBPACK FOOTER //
// ./src/app/infostan/slogctrl.ts